module.exports = __webpack_public_path__ + "img/financials.d465263b.svg";